import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { parseInt } from 'lodash';
import { TextField, CircularProgress, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import Invoice from '../../components/Invoice';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Backdrop from '@mui/material/Backdrop';
import InfoIcon from '@mui/icons-material/Info';
import { createFilterOptions } from "@mui/material/Autocomplete";

const LoadingOverlay = ({ loading }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'rgba(0, 0, 0, 0.8)', // Dark translucent background
      }}
      open={loading}
    >
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress
          color="secondary"
          size={62}
          thickness={4}
          sx={{ mb: 2 }} // Add some spacing below the spinner
        />
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: '#ffeb3b', // Bright yellow text
            animation: 'fade 2s infinite',
          }}
        >
          Loading, please wait...
        </Typography>
      </Box>
      <style>
        {`
              @keyframes fade {
                  0%, 100% { opacity: 1; }
                  50% { opacity: 0.5; }
              }
              `}
      </style>
    </Backdrop>
  );
};

function SellEntry(props) {
  const navigate = useNavigate();
  const itemCodeRef = useRef(null);
  const entrynoRef = useRef(null);
  const [showGrid, setShowGrid] = useState(true);
  const [formMode, setFormMode] = useState('edit');
  const [formModeUpdate, setFormModeUpdate] = useState('add');

  const [requestData, setRequestData] = useState([]);
  const [errorRowIndex, setErrorRowIndex] = useState(null);

  const location = useLocation();
  const flag = new URLSearchParams(location.search).get('flag');
  const title = new URLSearchParams(location.search).get('title');

  const [opbal, setOpbal] = useState(0);
  const [balance, setBalance] = useState(0);
  const [balances, setBalances] = useState({});
  const [lastBalance, setLastBalance] = useState(0);

  const [entryNo, setEntryNo] = useState('');
  const [trDate, setTrDate] = useState(getCurrentDate());
  const [PONo, setPONo] = useState('');
  const [PODate, setPODate] = useState(getCurrentDate());
  const [POEntryNo, setPOEntryNo] = useState(0);
  const [IDeptCode, setIDeptCode] = useState(0);
  const [BillNo, setBillNo] = useState(0);
  const [BillDate, setBillDate] = useState(getCurrentDate());
  const [GatePassNo, setGatePassNo] = useState(0);
  const [Narration1, setNarration1] = useState('');
  const [Narration2, setNarration2] = useState('');
  const [Narration3, setNarration3] = useState('');
  const [Narration4, setNarration4] = useState('');
  const [SubAccode, setSubAccode] = useState('');
  const [SubAcHead, setSubAcHead] = useState('');
  const [EmpCode, setEmpCode] = useState('');
  const [ComputerID, setComputerID] = useState('');
  const [VehicleCode, setVehicleCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [itemName, setItemName] = useState('');
  const [initialData, setInitialData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const limit = 100;

  const [Amt, setAmt] = useState(0);
  const [NetAmt, setNetAmt] = useState(0.00);

  const [gstRates, setGstRates] = useState([]);
  const [compMasterEntries, setCompMasterEntries] = useState([]);
  const [SubLedgerMasterEntries, setSubLedgerMasterEntries] = useState([]);
  const [VehicleMasterEntries, setVehicleMasterEntries] = useState([]);
  const [EmployeeMasterEntries, setEmployeeMasterEntries] = useState([]);
  const [packingMasterEntries, setPackingMasterEntries] = useState([]);
  const [settingMasterEntries, setSettingMasterEntries] = useState([]);
  const [ItemMaster, setItemMaster] = useState([]);
  const [ideptMasterEntries, setIDeptMasterEntries] = useState([]);
  const [ProcessEntry, setProcessEntry] = useState([]);
  const [POData, setPOData] = useState([]);
  const [showPDFComponent, setShowPDFComponent] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorType, setErrorType] = useState(null);
  let entryTotalNetAmt = {};
  const lastRowRef = useRef(null);

  const [filteredRows, setFilteredRows] = useState([]);
  const [savedBatch, setSavedBatch] = useState([]);
  const [targetRowIndex, setTargetRowIndex] = useState(null);

  const [savedData, setSavedData] = useState([]);
  const debouncedHandleItemCode = useRef();

  function debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  };

  useEffect(() => {
    debouncedHandleItemCode.current = debounce(async (entereditemCode, index) => {
      const selectedGroup = ItemMaster.find(group => group.ItCode == entereditemCode);

      if (selectedGroup) {
        try {
          const lastBalance = await fetchReportData2(getCurrentDate(), getCurrentDate(), selectedGroup.ItCode);

          setRows(prevRows => {
            const updated = [...prevRows];
            updated[index] = {
              ...updated[index],
              ItCode: entereditemCode,
              ItName: selectedGroup.ItName,
              OpBal: lastBalance,
            };
            return updated;
          });
        } catch (error) {
          console.error('Error fetching last balance:', error);
          setErrorMessage('Failed to fetch last balance.');
          setDialogOpen(true);
          setErrorType('ItCode');
          setErrorRowIndex(index);
        }
      } else {
        setRows(prevRows => {
          const updated = [...prevRows];
          updated[index] = {
            ...updated[index],
            ItCode: '',
            ItName: '',
            OpBal: '',
          };
          return updated;
        });
        /* setErrorMessage('Invalid ItCode. Please enter a valid ItCode.');
        setDialogOpen(true);
        setErrorType('ItCode');
        setErrorRowIndex(index); */
      }
    }, 400);
  }, [ItemMaster]);


  const [rows, setRows] = useState([
    {
      Flag: flag,
      ItCode: ItemMaster[0]?.ItCode,
      ItName: ItemMaster[0]?.ItName,
      OpBal: 0,
      ItemDesc: '',
      BatchNo: '',
      Qty: 0,
      Weight: 0,
      Rate: 0,
      Mfg: '',
      Expiry: '',
      Amt: 0,
      TotalAmt: 0,
      GstRate: '',
      GstAmt: 0,
      CgstAmt: '',
      SgstAmt: '',
      IgstAmt: '',
      NetAmt: 0,
      Narration: '',
      DeptCode: props.selectedDept,
      YearCode: props.selectedYear,
      CompCode: props.selectedCompany,
      USERID: props.name,
      ComputerID: savedData.length + 1,
    }
  ]);

  useEffect(() => {
    const flag = new URLSearchParams(location.search).get('flag');
    fetchProcessEntry(flag);
    fetchIDeptMaster();
    fetchSubLedgerMaster();
    fetchVehicleMaster();
    fetchEmpMaster();
    fetchGSTMaster();
    fetchPackingMaster();
    fetchSettingMaster();
    fetchReportData2();
    if (flag === 'GRN') {
      fetchPOData('POS');
      if (props.selectedCompany === 2) {
        fetchPOData('DESP');
      }
    } else if (flag === 'DESP') {
      fetchPOData('POC');
      if (props.selectedCompany === 1) {
        fetchPOData('PACK');
      }
    }
    fetchItemMaster();
    fetchCompMaster();
  }, [location.search]);

  useEffect(() => {
    if (showPDFComponent && (flag === "POS" || flag === "DESP")) {
      // console.log('called requsetData');
    }
  }, [requestData]);

  useEffect(() => {
    if (lastRowRef.current) {
      lastRowRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [rows]);

  useEffect(() => {
    const flag = new URLSearchParams(location.search).get('flag');
    if ((flag === 'DESP' || flag === 'GRN') && POData.length > 0) {
      fetchItemMaster();
    }
  }, [POData]);


  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.EntryNo > maxEntryNo) {
        maxEntryNo = entry.EntryNo;
      }
    }
    return maxEntryNo;
  };

  const fetchProcessEntry = async (flag) => {
    try {
      const response = await axios.get(`https://www.wingap.net.in/api/processentry/${flag}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`);
      if (response.data.length === 0) {
        setSavedData([]);
      }
      //console.log('Process Entry :', response.data);
      const maxNo = calculateMaxEntryNo(response.data);
      const nextNo = Number(maxNo) + 1;
      setEntryNo(nextNo);
      setProcessEntry(response.data);
      //console.log('process Entries:', response.data);
    } catch (error) {
      console.log('Error fetching Process entries:', error);
      return [];
    }
  };

  // const dedupByEntryNo = (data) => {
  //   const map = new Map();
  //   data.forEach((item) => {
  //     map.set(item.EntryNo, item); // Latest item will overwrite duplicate keys
  //   });
  //   return Array.from(map.values());
  // };

  // const fetchProcessEntry = async (flag) => {
  //   try {
  //     const response = await axios.get(`https://www.wingap.net.in/api/processentry/${flag}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`);
  //     if (response.data.length === 0) {
  //       setSavedData([]);
  //     }

  //     const newData = response.data;
  //     const merged = dedupByEntryNo([...ProcessEntry, ...newData]);

  //     if (newData.length < limit) setHasMoreData(false);
  //     setProcessEntry(merged);
  //     setInitialData(merged);

  //     //console.log('Process Entry :', response.data);
  //     const maxNo = calculateMaxEntryNo(response.data);
  //     const nextNo = Number(maxNo) + 1;
  //     setEntryNo(nextNo);
  //     //console.log('process Entries:', response.data);
  //   } catch (error) {
  //     console.log('Error fetching Process entries:', error);
  //     return [];
  //   }
  // };

  const fetchPOData = async (flag) => {
    try {
      const response = await axios.get(`https://www.wingap.net.in/api/processentry/${flag}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`);
      //console.log(response.data);
      setPOData((prevData) => [...prevData, ...response.data]);
    } catch (error) {
      console.log('error:', error);
    }
  };

  let uniquePOData = [];

  if (flag === 'GRN') {
    uniquePOData = Array.from(new Map(POData.filter(item => item.Flag === 'POS').map(item => [item.EntryNo, item])).values());
  } else if (flag === 'DESP') {
    uniquePOData = Array.from(new Map(POData.filter(item => item.Flag === 'POC').map(item => [item.EntryNo, item])).values());
  }

  // const filteredPODataa = uniquePOData.filter((poEntry) => !ProcessEntry.some((processEntry) => processEntry.PONo == poEntry.PONo));
  const filteredPODataa =
    formModeUpdate === 'edit'
      ? uniquePOData.filter((poEntry) => poEntry.EntryNo == POEntryNo)
      : uniquePOData.filter((poEntry) => !ProcessEntry.some((processEntry) => processEntry.PONo == poEntry.PONo));

  const fetchCompMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/company');
      setCompMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchEmpMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/employee');
      setEmployeeMasterEntries(response.data.sort((a, b) => a.EmpCode - b.EmpCode));
      //console.log(response)
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchVehicleMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/vehicle');
      setVehicleMasterEntries(response.data.sort((a, b) => (a.VehicleCode - b.VehicleCode)));
      // console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchPackingMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/packing');
      setPackingMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchIDeptMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/internalDept');
      setIDeptMasterEntries(response.data);
      //   console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchItemMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/items-master');
      let data = response.data;
      if (flag === 'DESP') {
        //console.log(POData);
        let pdata = POData.filter(el => el.Flag === 'PACK');

        const rawItCodes = [...new Set(pdata.map(el => el.RawItCode))];
        const filteredItemMaster = data.filter(item => rawItCodes.includes(item.ItCode));

        setItemMaster(filteredItemMaster);
      } else if (flag === 'GRN' && props.selectedCompany == 2) {
        // let pdata = POData.filter(el => el.Flag === 'DESP');
        // const itCodes = [...new Set(pdata.map(el => el.ItCode))];
        // const filteredItemMaster = data.filter(item => itCodes.includes(item.ItCode));
        //setItemMaster(filteredItemMaster);
        const itCodeSet = new Set(
          POData
            .filter(el => el.Flag === 'DESP')
            .map(el => el.ItCode)
        );

        setItemMaster(data.filter(item => itCodeSet.has(item.ItCode)));

      } else {
        setItemMaster(data.sort((a, b) => a.ItCode - b.ItCode));
      }
      //console.log("ItemMaster : ", response.data); // Log the fetched data
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchSubLedgerMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/subledgerMaster');
      setSubLedgerMasterEntries(response.data);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchSettingMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/setting');
      setSettingMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const isStockCheckEnabled = settingMasterEntries?.some(
    (s) =>
      s.SettingDesc1?.toLowerCase() === 'stockcheck' &&
      s.SettingValue1?.toLowerCase() === 'y'
  );


  const fetchGSTMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/gstrates');
      setGstRates(response.data);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const handleAcNameChange = (event, newValue) => {
    if (newValue) {
      setSubAccode(newValue.SubAcCode);
    } else {
      setSubAccode(SubLedgerMasterEntries[0].SubAcCode);
      setErrorMessage('Invalid Party Name. Please enter a valid Party Name.');
      setDialogOpen(true);
      setErrorType('SubAccode');
    }
  };

  const AddEntry = async () => {
    let updatedTableTempData = [];
    if ((formModeUpdate === "edit" && !props.canEdit) || (formModeUpdate === "add" && !props.canAdd)) {
      const action = formModeUpdate === "edit" ? "Update" : "Save";
      toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
      return;
    }
    try {
      const heatNoMapping = {
        POC: 1,
        POS: 2,
        GRN: 3,
        DESP: 7
      };

      const invalidEntries = rows.filter(entry => !entry.ItCode && !entry.ItName);
      const missingItems = rows.filter(entry => !ItemMaster.some(item => item.ItCode == entry.ItCode && item.ItName === entry.ItName));
      //console.log(missingItems);
      if (invalidEntries.length > 0) {
        toast.error('Error: Item (ItCode) is required.', { autoClose: 650 });
        return;
      }
      if (missingItems.length > 0) {
        toast.error(`ItemCode '${missingItems.map(entry => entry.ItCode)}' do not exist in Item Master.`, { autoClose: 700 });
        return;
      }

      updatedTableTempData = rows.map(entry => ({
        Flag: flag,
        EntryNo: entryNo,
        TrDate: trDate,
        SubAccode: parseInt(SubAccode),
        EmpCode: EmpCode,
        PONo: PONo,
        PODate: PODate,
        BillNo: BillNo,
        BillDate: BillDate,
        VehicleCode: VehicleCode,
        IDeptCode: IDeptCode,
        Narration1, Narration1,
        Narration2, Narration2,
        Narration3, Narration3,
        Narration4, Narration4,
        ItCode: entry.ItCode,
        ItemDesc: entry.ItemDesc,
        BatchNo: entry.BatchNo,
        Mfg: entry.Mfg,
        Expiry: entry.Expiry,
        Qty: entry.Qty,
        Weight: entry.Weight,
        Rate: entry.Rate,
        Amt: entry.Amt,
        GstRate: entry.GstRate,
        GstAmt: entry.GstAmt,
        CgstAmt: entry.CgstAmt,
        SgstAmt: entry.SgstAmt,
        IgstAmt: entry.IgstAmt,
        NetAmt: entry.NetAmt,
        ProdPlanNo: POEntryNo,
        Narration: entry.Narration,
        ComputerID: entry.ComputerID,
        HeatNo: heatNoMapping[flag] || 0,
        BatchQty: savedBatch,
        DeptCode: props.selectedDept,
        YearCode: props.selectedYear,
        CompCode: props.selectedCompany,
        USERID: props.name,
      }));

      //console.log('requestData', updatedTableTempData);
      setRequestData(updatedTableTempData);
      const requestData = updatedTableTempData;

      await axios.post(`https://www.wingap.net.in/api/processentry/${entryNo}/${flag}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, requestData);
      fetchProcessEntry(flag);
      setSavedData([]);
      setRows([
        {
          Flag: flag,
          ItCode: '',
          ItName: '',
          OpBal: 0,
          ItemDesc: '',
          BatchNo: '',
          Mfg: '',
          Expiry: '',
          Qty: 0,
          Weight: 0,
          Rate: 0,
          Amt: 0,
          TotalAmt: 0,
          GstRate: '',
          GstAmt: 0,
          CgstAmt: '',
          SgstAmt: '',
          IgstAmt: '',
          NetAmt: 0,
          Narration: '',
          DeptCode: props.selectedDept,
          YearCode: props.selectedYear,
          CompCode: props.selectedCompany,
          USERID: props.name,
          ComputerID: savedData.length + 1,
        }]);
      setShowPDFComponent(false);
      setFormModeUpdate('add');
      setFilteredRows([]);
      //setGstRate(gstRates[0].GSTRateCode);
      //setGstRateCode(gstRates[0].GSTRateCode);
      /* const selectedGroup1 = gstRates.find(group => group.GSTRateCode == ItemMaster[0].GSTRATECODE);
      if (selectedGroup1) {
        setGstRate(selectedGroup1.GSTPercent);
      } */
      setSubAccode(SubLedgerMasterEntries[0].SubAcCode);
      handleCancel();
      setTimeout(() => {
        if (entrynoRef.current) {
          entrynoRef.current.focus();
        }
      }, 0);

      if (formModeUpdate === 'add') {
        toast.success('Entry Saved Successfully.', { autoClose: 600 });
      } else {
        toast.success('Entry Updated Successfully.', { autoClose: 600 });
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const handleCancel = async () => {
    setFormMode('add');
    // Clear input fields
    setTrDate(getCurrentDate());
    setPONo('');
    setPODate(getCurrentDate());
    setIDeptCode('');
    setBillNo('');
    setBillDate(getCurrentDate());
    setPOEntryNo('');
    setNarration1('');
    setNarration2('');
    setNarration3('');
    setNarration4('');
    setSubAccode(SubLedgerMasterEntries[0].SubAcCode);
    setEmpCode(EmployeeMasterEntries[0].EmpCode);
    setNetAmt('');
  };


  const setEdit = async (entry) => {
    setShowGrid(false);
    setFormMode('add');
    setFormModeUpdate('edit');
    setShowPDFComponent(false);

    const filteredEntries = ProcessEntry.filter(data => data.EntryNo == entry);
    setSavedData(filteredEntries);
    setEntryNo(filteredEntries[0].EntryNo);
    const formattedDate = new Date(filteredEntries[0].TrDate).toISOString().split("T")[0];
    setTrDate(formattedDate);
    await handleEditBatchQty(formattedDate, filteredEntries[0].EntryNo);

    setSubAccode(filteredEntries[0].SubAccode);
    setEmpCode(filteredEntries[0].EmpCode);
    setPONo(filteredEntries[0].PONo);
    setPOEntryNo(filteredEntries[0].ProdPlanEntryNo);
    const formattedDate1 = new Date(filteredEntries[0].PODate).toISOString().split("T")[0];
    setPODate(formattedDate1);
    setIDeptCode(filteredEntries[0].IDeptCode);

    setVehicleCode(filteredEntries[0].VehicleCode);
    setNarration1(filteredEntries[0].Remark1);
    setNarration2(filteredEntries[0].Remark2);
    setNarration3(filteredEntries[0].Remark3);
    setNarration4(filteredEntries[0].Remark4);
    setComputerID(filteredEntries[0].ComputerID);

    const newRows = await Promise.all(filteredEntries.map(async (filteredEntry) => {
      const item = ItemMaster.find(item => item.ItCode == filteredEntry.ItCode);
      const gst = gstRates.find(grp => grp.GSTPercent == filteredEntry.GstRate);
      const manufactureDate = filteredEntry.Manufacture ? new Date(filteredEntry.Manufacture).toISOString().split("T")[0] : '';
      const expiryDate = filteredEntry.Expiry ? new Date(filteredEntry.Expiry).toISOString().split("T")[0] : ''; // Fallback if Expiry is null/undefined

      // Await the promise to get the actual lastBalance value
      const lastBalance = item ? await fetchReportData2(formattedDate, formattedDate, item.ItCode) : 0;

      return {
        ItCode: filteredEntry.ItCode || '',
        ItName: item ? item.ItName : '',
        OpBal: Number(lastBalance).toFixed(2),
        ItemDesc: filteredEntry.ItemDesc || '0',
        BatchNo: filteredEntry.BatchNo || '',
        Mfg: manufactureDate,
        Expiry: expiryDate,
        Rate: filteredEntry.Rate || '0',
        Qty: filteredEntry.Qty || '0',
        Weight: filteredEntry.Weight || '0',
        Amt: filteredEntry.Amt || '0',
        Unit: filteredEntry.Unit || '0',
        GstRate: gst ? gst.GSTPercent : '0',
        GstAmt: filteredEntry.GstAmt || '0',
        NetAmt: filteredEntry.NetAmt || '0'
      };
    }));

    setRows(newRows);
  };

  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteDistinctEntry(deleteEntryNo.entryNo, deleteEntryNo.flag);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteDistinctEntry = async (EntryNo, flag) => {
    if (!props.canDelete) {
      toast.error("You do not have permission to Delete.", { autoClose: 800 });
      return;
    }
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/distinctprocess/${EntryNo}/${flag}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        // fetchProcessEntries(flag);
        fetchProcessEntry(flag)
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    setErrorMessage('');
  };

  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleshowandhide = async () => {
    if (showGrid === true) {
      //const lastBalance = await fetchReportData2(getCurrentDate(), getCurrentDate(), ItemMaster[0].ItCode);
      const selectedItem = ItemMaster?.[0];

      if (selectedItem?.ItCode) {
        const lastBalance = await fetchReportData2(getCurrentDate(), getCurrentDate(), selectedItem.ItCode);

        setRows([{
          Flag: flag,
          ItCode: ItemMaster[0].ItCode,
          ItName: ItemMaster[0].ItName,
          OpBal: lastBalance,
          ItemDesc: '',
          BatchNo: '',
          Qty: 0,
          Weight: 0,
          Rate: 0,
          Amt: 0,
          TotalAmt: 0,
          GstRate: '',
          GstAmt: 0,
          CgstAmt: '',
          SgstAmt: '',
          IgstAmt: '',
          NetAmt: 0,
          Narration: '',
          DeptCode: props.selectedDept,
          YearCode: props.selectedYear,
          CompCode: props.selectedCompany,
          USERID: props.name,
          ComputerID: savedData.length + 1,
        }]);

      } else {
        console.error('No valid item found in ItemMaster');
      }

      fetchProcessEntry(flag)
      setFormMode('add');
      setShowGrid(false);
      setFormModeUpdate('add');
      setSavedData([]);
      setEmpCode(EmployeeMasterEntries[0]?.EmpCode);
      setSubAccode(SubLedgerMasterEntries[0]?.SubAcCode);
      setTrDate(getCurrentDate());
      setPODate(getCurrentDate());
      setIDeptCode('');
      setPOEntryNo('');
      setPONo('');
      setNetAmt('');
      setFilteredRows([]);
      setSavedBatch([]);
    } else {
      setShowGrid(true)
      setFormMode('edit');
      setFormModeUpdate('edit');
    }
  };

  const handleClearTemp = async () => {
    try {
      setSavedData([]);
      handleshowandhide();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const componentPDF = useRef();
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "ProcessEntryData",
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }

        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    AddEntry();
  };

  const handleCloseDialogWithPrint = () => {
    setShowPDFComponent(false);
    setTimeout(() => {
      setShowPDFComponent(true);
    }, 42);
    if (formModeUpdate === 'add') {
      AddEntry();
    } else if (formModeUpdate === 'edit') {
      AddEntry();
    }
    setOpenDialog(false);
  };

  const handleExitButtonClick = () => {
    navigate('/Dashboard');
  };

  entryTotalNetAmt = ProcessEntry.reduce((acc, entry) => {
    if (!acc[entry.EntryNo]) {
      acc[entry.EntryNo] = 0;
    }
    acc[entry.EntryNo] += entry.Qty;
    return acc;
  }, {});
  const uniqueEntries = new Set();

  const handleCloseErrorDialog = () => {
    setDialogOpen(false);
    if (errorType === 'ItCode' && errorRowIndex !== null) {
      setRows(prevRows =>
        prevRows.map((row, index) =>
          index === errorRowIndex
            ? {
              ...row,
              ItCode: ItemMaster[0].ItCode,
              ItName: ItemMaster[0].ItName
            }
            : row
        )
      );
    }
    if (errorType === 'SubAccode') {
      setSubAccode(SubLedgerMasterEntries[0].SubAcCode);
      setSubAcHead(SubLedgerMasterEntries[0].SubAcHead);
    }
    setErrorType(null);
    setErrorRowIndex(null);
  };

  const columnWidths = {
    ItCode: '74px',
    ItName: '270px',
    OpBal: '68px',
    ItemDesc: '140px',
    BatchNo: '130px',
    Mfg: '118px',
    Expiry: '118px',
    Unit: '82px',
    Rate: '82px',
    Qty: '82px',
    Weight: '82px',
    GSTRate: '90px',
    GSTAmt: '90px',
    NetAmt: '100px',
    Narration: '182px',
    TotalAmount: '100px',
    Actions: '70px',
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        Flag: flag,
        ItCode: ItemMaster[0].ItCode,
        ItName: ItemMaster[0].ItName,
        OpBal: 0,
        ItemDesc: '',
        BatchNo: '',
        Mfg: '',
        Expiry: '',
        Qty: 0,
        Weight: 0,
        Rate: 0,
        Amt: 0,
        TotalAmt: 0,
        GstRate: '',
        GstAmt: 0,
        CgstAmt: '',
        SgstAmt: '',
        IgstAmt: '',
        NetAmt: 0,
        Narration: '',
        DeptCode: props.selectedDept,
        YearCode: props.selectedYear,
        CompCode: props.selectedCompany,
        USERID: props.name,
        ComputerID: savedData.length + 1,
      }
    ]);
  };

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const newRows = [...rows];
    let row = newRows[index];
    row[name] = value;

    if (name === 'Qty' || name === 'Rate') {
      const qty = parseFloat(row['Qty']) || 0;
      const rate = parseFloat(row['Rate']) || 0;
      const amt = qty * rate;
      row['Amt'] = amt.toFixed(2);

      const gstRate = parseFloat(row.GstRate) || 0;
      const gstAmt = amt * (gstRate / 100);
      row['GstAmt'] = gstAmt.toFixed(2);

      const netAmt = amt * (1 + gstRate / 100);
      row['NetAmt'] = netAmt.toFixed(2);
    }
    if (name === 'Qty') {
      const selectedItem = ItemMaster.find((item) => item.ItCode == row.ItCode);
      if (selectedItem) {
        const packingEntry = packingMasterEntries.find(
          (packing) => packing.PackingCode == selectedItem.PackingCode
        );
        if (packingEntry) {
          const conversionFactor = packingEntry.ConversionFactor || 0;
          row['Weight'] = (conversionFactor * parseFloat(value || 0)).toFixed(2);
        }
      }
    }
    if (name === 'Weight') {
      const selectedItem = ItemMaster.find((item) => item.ItCode == row.ItCode);
      if (selectedItem) {
        const packingEntry = packingMasterEntries.find(
          (packing) => packing.PackingCode == selectedItem.PackingCode
        );
        if (packingEntry) {
          const conversionFactor = packingEntry.ConversionFactor || 0;
          row['Qty'] = conversionFactor > 0 ? (parseFloat(value || 0) / conversionFactor).toFixed(2) : 0;
        }
      }
    }
    setRows(newRows);
  };

  const handleDeleteRow = async (index) => {
    //console.log('Deleting row:', index, rows[index]);
    const row = rows[index];
    if (row.EntryNo && row.EmpCode) {
      try {
        await axios.delete(`https://www.wingap.net.in/api/paysheets/${row.EntryNo}/${row.EmpCode}`);
        toast.success('Record Deleted Successfully', { autoClose: 600 });
      } catch (error) {
        console.error('There was an error deleting the row!', error);
      }
    }
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };

  /* const handleBatchQtyChange = (index, newQty, targetRowIndex) => {
    // Allow empty string (user clearing the field)
    if (newQty === "") {
      const updatedFilteredRows = filteredRows.map((row, i) => {
        if (i === index) {
          return { ...row, Qty: null };
        }
        return row;
      });

      const relatedBatchNos = updatedFilteredRows
        .filter(fRow => fRow.Qty !== null && fRow.Qty !== undefined)
        .map(fRow => fRow.BatchNo)
        .join(',');

      const updatedRows = rows.map((row, i) => {
        if (i === targetRowIndex) {
          return { ...row, BatchNo: relatedBatchNos };
        }
        return row;
      });

      setFilteredRows(updatedFilteredRows);
      setRows(updatedRows);
      return;
    }

    newQty = parseFloat(newQty);
    if (isNaN(newQty)) return;

    const balQty = filteredRows[index]?.BalQty ?? 0;
    // Check if StockCheck setting is enabled
    const isStockCheckEnabled = settingMasterEntries?.some(
      setting => setting.SettingDesc1 === 'StockCheck' && setting.SettingValue === 'Y'
    );

    if (isStockCheckEnabled) {
      // Prefer BalWt if availabl

      if (newQty > balQty) {
        toast.warning(`Qty (${newQty}) cannot be greater than balance (${balQty})`, { autoClose: 920 });
        return;
      }

      if (newQty <= 0) {
        toast.warning("Qty must be greater than 0", { autoClose: 920 });
        return;
      }
    }

    // Proceed to update
    const updatedFilteredRows = filteredRows.map((row, i) => {
      if (i === index) {
        return { ...row, Qty: newQty };
      }
      return row;
    });

    const relatedBatchNos = updatedFilteredRows
      .filter(fRow => fRow.Qty !== null && fRow.Qty !== undefined)
      .map(fRow => fRow.BatchNo)
      .join(',');

    const updatedRows = rows.map((row, i) => {
      if (i === targetRowIndex) {
        return { ...row, BatchNo: relatedBatchNos };
      }
      return row;
    });

    setFilteredRows(updatedFilteredRows);
    setRows(updatedRows);
  }; */

  const handleBatchQtyChange = (index, newQty, targetRowIndex) => {
    if (newQty === "") {
      const updatedFilteredRows = filteredRows.map((row, i) => {
        if (i === index) return { ...row, Qty: null, Weight: null };
        return row;
      });

      const relatedBatchNos = updatedFilteredRows
        .filter(fRow => fRow.Qty !== null && fRow.Qty !== undefined)
        .map(fRow => fRow.BatchNo)
        .join(',');

      const updatedRows = rows.map((row, i) => {
        if (i === targetRowIndex) {
          return { ...row, BatchNo: relatedBatchNos };
        }
        return row;
      });

      setFilteredRows(updatedFilteredRows);
      setRows(updatedRows);
      return;
    }

    newQty = parseFloat(newQty);
    if (isNaN(newQty)) return;

    const balQty = filteredRows[index]?.BalQty ?? 0;
    const isStockCheckEnabled = settingMasterEntries?.some(
      setting => setting.SettingDesc1 === 'StockCheck' && setting.SettingValue === 'Y'
    );

    if (isStockCheckEnabled) {
      if (newQty > balQty) {
        toast.warning(`Qty (${newQty}) cannot be greater than balance (${balQty})`, { autoClose: 920 });
        return;
      }
      if (newQty < 0) {
        toast.warning("Qty must be greater than 0", { autoClose: 920 });
        return;
      }
    }

    // Get ItCode and ConversionFactor
    const currentRow = filteredRows[index];
    const selectedItem = ItemMaster.find(item => item.ItCode === currentRow.ItCode);
    const packingEntry = packingMasterEntries.find(
      pack => pack.PackingCode === selectedItem?.PackingCode
    );
    const conversionFactor = packingEntry?.ConversionFactor || 0;

    const calculatedWeight = parseFloat((newQty * conversionFactor).toFixed(2));

    const updatedFilteredRows = filteredRows.map((row, i) => {
      if (i === index) {
        return { ...row, Qty: newQty, Weight: calculatedWeight };
      }
      return row;
    });

    const relatedBatchNos = updatedFilteredRows
      .filter(fRow => fRow.Qty !== null && fRow.Qty !== undefined)
      .map(fRow => fRow.BatchNo)
      .join(',');

    const updatedRows = rows.map((row, i) => {
      if (i === targetRowIndex) {
        return { ...row, BatchNo: relatedBatchNos };
      }
      return row;
    });

    setFilteredRows(updatedFilteredRows);
    setRows(updatedRows);
  };

  const handleBatchWtChange = (index, newWt, targetRowIndex) => {
    if (newWt === "") {
      const updatedFilteredRows = filteredRows.map((row, i) => {
        if (i === index) return { ...row, Weight: null };
        return row;
      });

      setFilteredRows(updatedFilteredRows);
      return;
    }

    newWt = parseFloat(newWt);
    if (isNaN(newWt)) return;

    const balWt = filteredRows[index]?.BalWt ?? 0;

    const isStockCheckEnabled = settingMasterEntries?.some(
      setting => setting.SettingDesc1 === 'StockCheck' && setting.SettingValue === 'Y'
    );

    if (isStockCheckEnabled) {
      if (newWt > balWt) {
        toast.warning(`Weight (${newWt}) cannot be greater than balance Weight (${balWt})`, { autoClose: 900 });
        return;
      }

      if (newWt <= 0) {
        toast.warning("Weight must be greater than 0", { autoClose: 900 });
        return;
      }
    }

    const updatedFilteredRows = filteredRows.map((row, i) => {
      if (i === index) return { ...row, Weight: newWt };
      return row;
    });

    const updatedRows = rows.map((row, i) => {
      if (i === targetRowIndex) {
        const updatedFiltered = updatedFilteredRows[index];
        return { ...row, Weight: updatedFiltered?.Weight };
      }
      return row;
    });

    setFilteredRows(updatedFilteredRows);
    setRows(updatedRows);
  };

  const handleSave = () => {
    if (filteredRows.length > 0) {
      setSavedBatch((prevData) => {
        const updatedData = [...prevData, ...filteredRows];
        return updatedData;
      });
      setFilteredRows([]); // Clear filteredRows after saving
      toast.success('Batch Qty Saved Successfully!', { autoClose: 760 });
    } else {
      toast.warning('No data to save!', { autoClose: 760 });
    }
  };

  const handleBatchQty = async (date, itcode) => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/batchQty', {
        params: {
          startDate: date,
          ItCode: parseInt(itcode),
          CompCode: props.selectedCompany
        }
      });

      const filteredData = response.data.filter(item => item.ItCode == parseInt(itcode));
      //console.log("filtered Data",filteredData);
      setFilteredRows(filteredData);
    } catch (error) {
      console.error('Error fetching balances:', error);
    }
  };

  const handleEditBatchQty = async (trdate, entryno, itcode) => {
    try {
      const params = {
        TrDate: trdate,
        EntryNo: parseInt(entryno),
      };

      if (itcode) {
        params.ItCode = parseInt(itcode);
      }

      const response = await axios.get(`https://www.wingap.net.in/api/subProcessEntry/${flag}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, {
        params: params
      });

      if (itcode) {
        const filteredData = response.data.filter(item => item.ItCode === parseInt(itcode));
        setFilteredRows(filteredData);
      } else {
        //console.log(response.data);
        setFilteredRows(response.data);
      }
    } catch (error) {
      console.error('Error fetching balances:', error);
    }
  };

  const fetchReportData2 = async (formattedDate1, currentDate, itCode) => {
    //console.log(formattedDate1, currentDate, itCode);
    if (!formattedDate1 || !currentDate || !itCode) {
      console.error('Missing required parameters:', { formattedDate1, currentDate, itCode });
      return;
    }
    setLoading(true);

    try {
      const requestData = {
        startDate: formattedDate1,
        endDate: currentDate,
        itemCode: itCode,
        CompCode: props.selectedCompany,
      };

      // Fetch opening balance
      const opBalFromReport = await handleStockReport(formattedDate1, itCode);

      // Axios GET request with progress tracking
      const response = await axios.get(`https://www.wingap.net.in/api/stockLedgerr`, {
        params: requestData
      });
      //console.log(opBalFromReport, requestData, response.data);

      if (response.data.length === 0) {
        setOpbal('');
        setBalance('');
        return opBalFromReport;
      }

      let opbal = Number(opBalFromReport) || 0;
      /* const data = response.data.map((rowData) => {
        const InQty = rowData.InQty || 0;
        const OutQty = rowData.OutQty || 0;

        opbal += InQty - OutQty;
        return { ...rowData, BalQty: opbal };
      }); */

      return opbal;
    } catch (error) {
      console.error('Error fetching report data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStockReport = async (date, itcode) => {
    setLoading(true);
    try {
      const response = await axios.get('https://www.wingap.net.in/api/stockkReport', {
        params: {
          startDate: BeforeformatDate1(date),
          ItCode: parseInt(itcode),
          CompCode: props.selectedCompany
        },
      });
      const balanceData = response.data.find(item => item.ItCode == parseInt(itcode));
      const opBal = balanceData?.BalQty ?? 0; // Use nullish coalescing to handle undefined
      return opBal;
    } catch (error) {
      console.error('Error fetching stock report:', error);
      return 0; // Return 0 as a fallback to avoid undefined
    } finally {
      setLoading(false);
    }
  };

  const BeforeformatDate1 = (dateString) => {
    const date = new Date(dateString);
    date.setDate(date.getDate());
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSelectChange = async (e) => {
    const selectedEntryNo = e.target.value;

    const allMatchingEntries = POData.filter((entry) => entry.EntryNo == selectedEntryNo);
    //const grnEntries = ProcessEntry.filter((entry) => entry.PONo == allMatchingEntries[0].PONo);

    //console.log(allMatchingEntries);
    if (allMatchingEntries.length > 0) {
      setPOEntryNo(allMatchingEntries[0].EntryNo);
      setPONo(allMatchingEntries[0].PONo);

      const formattedDate1 = new Date(allMatchingEntries[0].PODate).toISOString().split("T")[0];
      setPODate(formattedDate1);

      setSubAccode(allMatchingEntries[0].SubAccode);
      setEmpCode(allMatchingEntries[0].EmpCode);
      setBillNo(allMatchingEntries[0].BillNo);

      const formattedDate = new Date(allMatchingEntries[0].BillDate).toISOString().split("T")[0];
      setBillDate(formattedDate);

      setIDeptCode(allMatchingEntries[0].IDeptCode);
      setVehicleCode(allMatchingEntries[0].VehicleCode);
      setNarration1(allMatchingEntries[0].Remark1);
      setNarration2(allMatchingEntries[0].Remark2);
      setNarration3(allMatchingEntries[0].Remark3);
      setNarration4(allMatchingEntries[0].Remark4);
      //console.log(allMatchingEntries);

      const newRows = await Promise.all(
        allMatchingEntries.map(async (filteredEntry) => {
          const item = ItemMaster.find((item) => item.ItCode == filteredEntry.ItCode);

          // const lastBalance = await fetchReportData2(filteredEntry.TrDate, getCurrentDate(), filteredEntry.ItCode);
          let lastBalance = 0;
          try {
            lastBalance = await fetchReportData2(
              filteredEntry.TrDate,
              getCurrentDate(),
              filteredEntry.ItCode
            );
          } catch (error) {
            console.error("Error fetching last balance:", error);
          }

          return {
            ItCode: filteredEntry.ItCode || '',
            ItName: item ? item.ItName : '',
            OpBal: lastBalance ? lastBalance.toFixed(2) : '0.00',
            ItemDesc: filteredEntry.ItemDesc || '',
            Qty: filteredEntry.Qty || '0',
            Weight: filteredEntry.Weight || '0',
            Rate: filteredEntry.Rate || '0',
            Amt: filteredEntry.Amt || '0',
            GstRate: filteredEntry.GstRate || '0',
            GstAmt: filteredEntry.GstAmt || '0',
            NetAmt: filteredEntry.NetAmt || '0',
            ComputerID: savedData.length + 1,
          };
        }));

      setRows(newRows);
    } else {
      setPONo("");
      setRows([]);
    }
  };


  const filterOptions = createFilterOptions({
    stringify: (option) => `${option.PartNo} ${option.ItName}`,
    matchFrom: "any", // allow match from anywhere
  });

  const totalQty = rows.reduce((total, row) => total + (parseFloat(row.Qty) || 0), 0);
  const totalWeight = rows.reduce((total, row) => total + (parseFloat(row.Weight) || 0), 0);

  return (
    <>
      <ToastContainer />
      <LoadingOverlay loading={loading} />
      {!loading && <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px', paddingTop: '0px' }}>
        <div style={!showGrid ? { display: 'flex', borderRadius: '3px', flexDirection: 'column', boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.35)', backgroundColor: '#fff', color: "black", padding: '5px' } : {}}>
          {/* New Entry Top Bar */}

          {!showGrid &&
            <>
              <div style={{ maxWidth: '100%' }}>
                <h2 style={{ fontSize: '20px', marginBottom: '2px', marginRight: '10px', marginTop: '0px' }}>{formMode === 'add' ? 'ADD' : 'EDIT'} {title}</h2>

                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px', backgroundColor: '#DEDADA', borderRadius: '5px', color: '#333', padding: '5px', width: '100%' }}>

                  <div style={{ width: (flag === 'POS' || flag === 'POC') ? '70%' : '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '4px', width: '100%' }}>
                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "DESP" || flag === "CONS" || flag === "MISSUE") &&
                        <div style={{ maxWidth: '100px', marginRight: '5px' }}>
                          <label htmlFor="entryNo">Entry No<br /></label>
                          <input
                            type="text"
                            id="entryNo"
                            ref={entrynoRef}
                            value={entryNo}
                            readOnly
                            placeholder="EntryNo"
                            style={{ padding: '5px', width: '100%' }}
                          />
                        </div>}

                      {(flag === "GRN" || flag === "DESP") &&
                        <div style={{ flex: .33, marginBottom: '5px', marginRight: '5px' }}>
                          <label htmlFor="POEntryNo">{flag === "GRN" ? 'PO(supp.) EntryNo' : 'PO(cust.) EntryNo'}</label><br />
                          <select
                            value={POEntryNo}
                            onChange={handleSelectChange}
                            style={{ padding: '5px', width: '100%' }}
                          >
                            <option value="">Select EntryNo</option>
                            {filteredPODataa.map((group) => (
                              <option key={group.EntryNo} value={group.EntryNo}>
                                {group.PONo}
                              </option>
                            ))}
                          </select>
                        </div>}

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "PROD" || flag === "QUAL" || flag === "PACK" || flag === "DESP" || flag === "PRODPL") &&
                        <div style={{ flex: 1.1, marginRight: '2px' }}>
                          <label htmlFor="party">Party Name<br /></label>
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={SubLedgerMasterEntries}
                            value={SubLedgerMasterEntries.find(item => item.SubAcCode == SubAccode) || null}
                            onChange={(event, newValue) => handleAcNameChange(event, newValue)}
                            getOptionLabel={(option) => option.SubAcHead}
                            style={{ marginBottom: '5px', marginRight: '2px', height: '10px' }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                sx={{
                                  marginBottom: '5px',
                                  width: '100%',
                                  '& .MuiInputBase-input': {
                                    color: 'black',
                                    padding: '1px',
                                    height: '1px'
                                  },
                                  '& .MuiInputLabel-root': {
                                    color: 'black',
                                  },
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'black',
                                  },
                                  '& .MuiSvgIcon-root': {
                                    color: 'black',
                                  },
                                  backgroundColor: 'white'
                                }}
                              />
                            )}
                          />
                        </div>}

                      {(flag === "CONS" || flag === "MISSUE") &&
                        <div style={{ flex: .38, marginBottom: '5px', marginRight: '5px' }}>
                          <label htmlFor="DeptName">DeptName</label><br />
                          <select
                            value={IDeptCode}
                            onChange={(e) => {
                              const selectedEntryNo = e.target.value;
                              setIDeptCode(selectedEntryNo);
                            }}
                            style={{ padding: '5px', width: '100%' }}
                          >
                            <option value="">Select Dept</option>
                            {ideptMasterEntries.map((group) => (
                              <option key={group.IDeptCode} value={group.IDeptCode}>
                                {group.IDeptName}
                              </option>
                            ))}
                          </select>
                        </div>}

                      {(flag === "GRN" || flag === "DESP") && <div style={{ maxWidth: '100px', marginRight: '5px' }}>
                        <label htmlFor="Bill No">Bill No</label><br />
                        <input
                          type="text"
                          id="BillNo"
                          value={BillNo}
                          onChange={(e) => setBillNo(e.target.value)}
                          placeholder="Bill No"
                          style={{ padding: '5px', width: '100%' }}
                        />
                      </div>}

                      {(flag === "GRN" || flag === "DESP") && <div style={{ maxWidth: '100px', marginRight: '5px' }}>
                        <label htmlFor="Bill Date">Bill Date</label><br />
                        <input
                          type="date"
                          id="BillDate"
                          value={BillDate}
                          onChange={(e) => setBillDate(e.target.value)}
                          placeholder="Bill Date"
                          style={{ padding: '5px', width: '100%' }}
                        />
                      </div>}
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '4px', width: '100%' }}>

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "CONS" || flag === "MISSUE" || flag === "QUAL" || flag === "PACK" || flag === "DESP" || flag === "PRODPL") &&
                        <div style={{ maxWidth: '120px', marginRight: '5px' }}>
                          <label htmlFor="TRDate">TrDate<br /></label>
                          <input
                            id="Date"
                            type="date"
                            value={trDate}
                            onChange={(e) => setTrDate(e.target.value)}
                            style={{ padding: '5px', width: '100%' }}
                          />
                        </div>}

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "DESP") && <div style={{ maxWidth: '120px', marginBottom: '5px', marginRight: '5px' }}>
                        <label htmlFor="PONo">PO No:</label><br />
                        <input
                          type="text"
                          id="PONo"
                          value={PONo}
                          onChange={(e) => setPONo(e.target.value)}
                          placeholder="PO No."
                          style={{ padding: '5px', width: '100%' }}
                        />
                      </div>}

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "DESP") && <div style={{ maxWidth: '120px', marginRight: '5px' }}>
                        <label htmlFor="PONo">PO Date:</label><br />
                        <input
                          type="date"
                          id="PODate"
                          value={PODate}
                          onChange={(e) => setPODate(e.target.value)}
                          placeholder="PO Date"
                          style={{ padding: '5px', width: '100%' }}
                        />
                      </div>}

                      {(flag === "GRN" || flag === "DESP") && <div style={{ flex: .4, marginRight: '5px' }}>
                        <label htmlFor="GatePassNo">GatePassNo</label><br />
                        <input
                          type="text"
                          id="GatePassNo"
                          value={GatePassNo}
                          onChange={(e) => setGatePassNo(e.target.value)}
                          placeholder="GatePassNo"
                          style={{ padding: '5px', width: '100%' }}
                        />
                      </div>}

                      {(flag === "GRN" || flag === "DESP") && (
                        <div style={{ flex: .5, marginRight: '5px' }}>
                          <label htmlFor="VehicleNo">Vehicle No</label><br />
                          <select
                            value={VehicleCode}
                            onChange={(e) => {
                              const selectedGroupName = e.target.value;
                              setVehicleCode(selectedGroupName);
                              const selectedGroup = VehicleMasterEntries.find(group => group.VehicleCode === selectedGroupName);
                              if (selectedGroup) {
                                setVehicleCode(selectedGroup.VehicleCode);
                              }
                            }}
                            style={{ padding: '5px', width: '100%' }}
                          >
                            <option value="">Select Vehicle</option>
                            {VehicleMasterEntries.map((group) => (
                              <option key={group.VehicleCode} value={group.VehicleCode}>{group.VehicleNo}</option>
                            ))}
                          </select>
                        </div>
                      )}

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "DESP" || flag === "CONS" || flag === "MISSUE") &&
                        <div style={{ flex: .7, marginRight: '5px' }}>
                          <label htmlFor="EmpCode">EmpCode</label><br />
                          <select
                            value={EmpCode}
                            onChange={(e) => {
                              const selectedGroupName = e.target.value;
                              setEmpCode(selectedGroupName);
                              const selectedGroup = EmployeeMasterEntries.find(group => group.EmpCode == selectedGroupName);
                              if (selectedGroup) {
                                setEmpCode(selectedGroup.EmpCode);
                              }
                            }}
                            style={{ padding: '5px', width: '100%' }}
                          >
                            {EmployeeMasterEntries.map((group) => (
                              <option key={group.EmpCode} value={group.EmpCode}>{group.EmpName}</option>
                            ))}
                          </select>
                        </div>}

                      {(flag === "GRN" || flag === "CONS" || flag === "DESP" || flag === "MISSUE") && <div style={{ flex: 1 }}>
                        <label htmlFor="Narration1">Narration1</label><br />
                        <input
                          type="text"
                          id="Narration1"
                          value={Narration1}
                          onChange={(e) => setNarration1(e.target.value)}
                          placeholder="Narration1"
                          style={{ padding: '5px', width: '100%' }}
                        />
                      </div>}
                    </div>
                  </div>
                  {(flag === 'POS' || flag === 'POC') && <div style={{ width: '30%' }}>
                    {(flag === "POC" || flag === "POS") && <div>
                      <input
                        type="text"
                        id="Narration"
                        value={Narration1}
                        onChange={(e) => setNarration1(e.target.value)}
                        placeholder="Narration1"
                        style={{ padding: '4px', width: '100%' }}
                      />
                    </div>}
                    {(flag === "POC" || flag === "POS") && <div>
                      <input
                        type="text"
                        id="Narration"
                        value={Narration2}
                        onChange={(e) => setNarration2(e.target.value)}
                        placeholder="Narration2"
                        style={{ padding: '4px', width: '100%' }}
                      />
                    </div>}
                    {(flag === "POC" || flag === "POS") && <div>
                      <input
                        type="text"
                        id="Narration"
                        value={Narration3}
                        onChange={(e) => setNarration3(e.target.value)}
                        placeholder="Narration3"
                        style={{ padding: '4px', width: '100%' }}
                      />
                    </div>}
                    {(flag === "POC" || flag === "POS") && <div>
                      <input
                        type="text"
                        id="Narration"
                        value={Narration4}
                        onChange={(e) => setNarration4(e.target.value)}
                        placeholder="Narration4"
                        style={{ padding: '4px', width: '100%' }}
                      />
                    </div>}
                  </div>}

                  {(flag === 'DESP') && <div style={{ width: '42%' }}>
                    <>
                      <div
                        style={{
                          backgroundColor: 'white',
                          maxHeight: '140px',
                          overflowY: 'auto',
                        }}
                      >
                        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                          <thead style={{ backgroundColor: '#DEDADA', position: 'sticky', top: 0, zIndex: 10 }}>
                            <tr>
                              <th style={{ border: '1px solid #333', padding: '2px' }}>ItemName</th>
                              <th style={{ border: '1px solid #333', padding: '2px' }}>BatchNo</th>
                              <th style={{ border: '1px solid #333', padding: '2px' }}>Qty | Wt</th>
                              <th style={{ border: '1px solid #333', padding: '2px' }}>Qty</th>
                              <th style={{ border: '1px solid #333', padding: '2px' }}>Weight</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredRows.map((row, index) => {
                              const selectedGroup = ItemMaster.find(group => group.ItCode == row.ItCode)?.ItName;
                              return (
                                <tr key={index}>
                                  <td style={{ padding: '1px', fontSize: '9px', width: '100px', border: '1px solid #333', textAlign: 'left' }}>
                                    {selectedGroup ? selectedGroup : ''}
                                  </td>
                                  <td style={{ padding: '1px', width: '60px', border: '1px solid #333', textAlign: 'left' }}>
                                    {row.BatchNo || 'N/A'}
                                  </td>
                                  <td style={{ padding: '1px', width: '70px', border: '1px solid #333', textAlign: 'right' }}>
                                    {row.BalQty ? row.BalQty : 0}{flag === 'DESP' && row.BalWt !== undefined && ` | ${row.BalWt.toFixed(2)}`}
                                  </td>
                                  <td style={{ padding: '0', width: '60px', border: '1px solid #333', textAlign: 'right' }}>
                                    <input
                                      type="number"
                                      value={row.Qty || ''}
                                      style={{ width: '100%', textAlign: 'right', border: 'none' }}
                                      onChange={(e) => handleBatchQtyChange(index, e.target.value, targetRowIndex)}
                                    />
                                  </td>
                                  <td style={{ padding: '0', width: '60px', border: '1px solid #333', textAlign: 'right' }}>
                                    <input
                                      type="number"
                                      value={row.Weight || ''}
                                      style={{ width: '100%', textAlign: 'right', border: 'none' }}
                                      onChange={(e) => handleBatchWtChange(index, e.target.value, targetRowIndex)}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                          <tfoot>
                            <tr style={{ backgroundColor: '#f1f1f1', fontWeight: 'bold' }}>
                              <td colSpan={3} style={{ textAlign: 'right', padding: '4px', border: '1px solid #333' }}>Total</td>
                              <td style={{ textAlign: 'right', padding: '2px', border: '1px solid #333' }}>
                                {formModeUpdate === 'add' ? savedBatch
                                  .reduce((sum, row) => sum + (parseFloat(row.Qty) || 0), 0)
                                  .toFixed(2)
                                  : filteredRows.reduce((sum, row) => sum + (parseFloat(row.Qty) || 0), 0)
                                    .toFixed(2)}
                              </td>
                              <td style={{ textAlign: 'right', padding: '2px', border: '1px solid #333' }}>
                                {formModeUpdate === 'add' ? savedBatch
                                  .reduce((sum, row) => sum + (parseFloat(row.Weight) || 0), 0)
                                  .toFixed(2)
                                  : filteredRows
                                    .reduce((sum, row) => sum + (parseFloat(row.Weight) || 0), 0)
                                    .toFixed(2)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                      {(formMode == 'add' && flag == 'DESP') && <div style={{ marginTop: '10px', float: 'right' }}>
                        <button onClick={handleSave} style={{ padding: '10px', backgroundColor: '#4caf50', color: 'white', border: 'none' }}>
                          Save
                        </button>
                      </div>}
                    </>
                  </div>}
                </div>
              </div>
            </>
          }

          {!showGrid && (
            <>
              <div
                style={{
                  display: "flex",
                  backgroundColor: "white",
                  borderRadius: "5px",
                  marginBottom: "5px",
                  padding: "6px",
                  overflowY: "auto",
                  maxHeight: "400px",
                }}
              >
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    border: '1px solid #ccc',
                    tableLayout: 'fixed'
                  }}
                >
                  <thead style={{ position: 'sticky', top: 0, zIndex: 10, height: '32px' }}>
                    <tr>
                      <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: '50px' }}>Sr No.</th>

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "CONS" || flag === "PROD" || flag === "MISSUE" || flag === "QUAL" || flag === "PACK" || flag === "DESP" || flag === "PRODPL") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['ItCode'] || '60px' }}>ItCode</th>
                      )}

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "CONS" || flag === "PROD" || flag === "MISSUE" || flag === "QUAL" || flag === "PACK" || flag === "DESP" || flag === "PRODPL") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['ItName'] || '60px' }}>ItName</th>
                      )}

                      {(flag === "GRN" || flag === "CONS" || flag === 'POC' || flag === 'POS' || flag === "DESP" || flag === "MISSUE") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['OpBal'] || '60px' }}>Balance</th>
                      )}

                      {(flag === "GRN" || flag === "CONS" || flag === 'POC' || flag === 'POS' || flag === "DESP" || flag === "MISSUE") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['ItemDesc'] || '60px' }}>ItemDesc</th>
                      )}

                      {(flag === "GRN" || flag === "DESP") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['BatchNo'] || '60px' }}>BatchNo</th>
                      )}

                      {(flag === "GRN") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['Mfg'] || '60px' }}>Mfg</th>
                      )}

                      {(flag === "GRN") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['Expiry'] || '60px' }}>Expiry</th>
                      )}

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "CONS" || flag === "DESP" || flag === "MISSUE") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['Rate'] || '60px' }}>Rate</th>
                      )}

                      {/* {(flag === "GRN" || flag === "CONS" || flag === "DESP" || flag === "MISSUE") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['Unit'] || '60px' }}>Unit</th>
                      )} */}

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "CONS" || flag === "MISSUE" || flag === "DESP") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['Qty'] || '60px' }}>Qty</th>
                      )}

                      {(flag === "POC" || flag === "DESP") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['Qty'] || '60px' }}>Weight</th>
                      )}

                      {(flag === "GRN" || flag === "CONS" || flag === "POC" || flag === "POS" || flag === "DESP" || flag === "MISSUE") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['TotalAmount'] || '60px' }}>TotalAmount</th>
                      )}

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "DESP") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['GSTRate'] || '60px' }}>GSTRate</th>
                      )}

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "DESP") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['GSTAmt'] || '60px' }}>GSTAmt</th>
                      )}

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "DESP") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['NetAmt'] || '60px' }}>NetAmt</th>
                      )}

                      {(flag === "GRN" || flag === "DESP") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['Narration'] || '60px' }}>Narration</th>
                      )}
                      {(flag === "DESP") && (
                        <th style={{ backgroundColor: '#1168AA', color: 'white', border: '1px solid white', width: columnWidths['Actions'] || '60px' }}>Action</th>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={index} ref={index === rows.length - 1 ? lastRowRef : null}>
                        <td style={{ padding: '5px', border: '1px solid #333' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                            {index + 1}
                            <IconButton onClick={() => handleDeleteRow(index)} aria-label="delete">
                              <DeleteIcon style={{ color: 'red' }} />
                            </IconButton>
                          </div>
                        </td>

                        {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "CONS" || flag === "PROD" || flag === "MISSUE" || flag === "QUAL" || flag === "PACK" || flag === "DESP" || flag === "PRODPL") &&
                          <td style={{ padding: '1px', border: '1px solid #333' }}>
                            <input
                              type="number"
                              name="ItCode"
                              ref={itemCodeRef}
                              value={row.ItCode}
                              onInput={(e) => {
                                const entereditemCode = e.target.value;

                                const updatedRows = [...rows];
                                updatedRows[index] = {
                                  ...updatedRows[index],
                                  ItCode: entereditemCode,
                                };
                                setRows(updatedRows);

                                debouncedHandleItemCode.current(entereditemCode, index);
                              }}

                              /* onInput={async (e) => {
                                const entereditemCode = e.target.value;
                                const updatedRows = [...rows];

                                const selectedGroup = ItemMaster.find(group => group.ItCode == entereditemCode);
                                if (selectedGroup) {
                                  try {
                                    const lastBalance = await fetchReportData2(getCurrentDate(), getCurrentDate(), selectedGroup.ItCode);

                                    updatedRows[index] = {
                                      ...updatedRows[index],
                                      ItCode: entereditemCode,
                                      ItName: selectedGroup.ItName,
                                      OpBal: lastBalance,
                                    };
                                    setRows(updatedRows);
                                  } catch (error) {
                                    console.error('Error fetching last balance:', error);
                                    setErrorMessage('Failed to fetch last balance.');
                                    setDialogOpen(true);
                                    setErrorType('ItCode');
                                    setErrorRowIndex(index);
                                  }
                                } else {
                                  updatedRows[index] = {
                                    ...updatedRows[index],
                                    ItCode: entereditemCode,
                                    ItName: '',
                                    OpBal: '',
                                  };
                                  setRows(updatedRows);
                                  setErrorMessage('Invalid ItCode. Please enter a valid ItCode.');
                                  setDialogOpen(true);
                                  setErrorType('ItCode');
                                  setErrorRowIndex(index);
                                }
                              }} */
                              placeholder="ItCode"
                              style={{ padding: '5px', width: '100%', border: 'none' }}
                            />
                          </td>}
                        {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "CONS" || flag === "PROD" || flag === "MISSUE" || flag === "QUAL" || flag === "PACK" || flag === "DESP" || flag === "PRODPL") &&
                          <td style={{ padding: '1px', border: '1px solid #333' }}>
                            <Autocomplete
                              //value={row.ItName || ''}
                              value={
                                ItemMaster.find(group => group.ItCode === Number(row.ItCode)) || null
                              }
                              onChange={async (event, newValue) => {
                                const updatedRows = [...rows];
                                if (!newValue) {
                                  // Handle clear/reset
                                  updatedRows[index] = {
                                    ...updatedRows[index],
                                    ItCode: '',
                                    ItName: '',
                                    OpBal: '',
                                  };
                                  setRows(updatedRows);
                                  return;
                                }

                                const selectedGroup = ItemMaster.find(group => group.ItCode === newValue.ItCode);
                                if (selectedGroup) {
                                  try {
                                    const lastBalance = await fetchReportData2(getCurrentDate(), getCurrentDate(), selectedGroup.ItCode);

                                    updatedRows[index] = {
                                      ...updatedRows[index],
                                      ItCode: selectedGroup.ItCode,
                                      ItName: newValue.ItName,
                                      OpBal: lastBalance,
                                    };
                                    setRows(updatedRows);
                                  } catch (error) {
                                    console.error('Error fetching last balance:', error);
                                    setErrorMessage('Failed to fetch last balance.');
                                    setDialogOpen(true);
                                    setErrorType('ItCode');
                                    setErrorRowIndex(index);
                                  }
                                } else {
                                  updatedRows[index] = {
                                    ...updatedRows[index],
                                    ItName: '',
                                    OpBal: '',
                                  };
                                  setRows(updatedRows);
                                  setItemName('');
                                  /* setErrorMessage('Invalid ItemName. Please enter a valid ItemName.');
                                  setDialogOpen(true);
                                  setErrorType('ItCode');
                                  setErrorRowIndex(index); */
                                }
                              }}

                              //options={ItemMaster.map((option) => option.ItName)}
                              options={ItemMaster}
                              filterOptions={filterOptions}
                              getOptionLabel={(option) =>
                                option.PartNo
                                  ? `${option.PartNo} - ${option.ItName}`
                                  : option.ItName
                              }
                              renderOption={(props, option) => (
                                <li {...props} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                  <span style={{ textAlign: 'left' }}>{option.PartNo}</span>
                                  <span style={{ textAlign: 'right', fontWeight:600 }}>{option.ItName}</span>
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  sx={{
                                    marginBottom: '5px',
                                    width: '100%',
                                    '& .MuiInputBase-input': {
                                      color: 'black',
                                      padding: '1px',
                                      height: '1px'
                                    },
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiSvgIcon-root': {
                                      color: 'black',
                                    },
                                    backgroundColor: 'white'
                                  }}
                                />
                              )}
                            />
                          </td>}

                        {(flag === "GRN" || flag === "CONS" || flag === "POC" || flag === "POS" || flag === "DESP" || flag === "MISSUE") && <td style={{ padding: '1px', border: '1px solid #333' }}>
                          <input
                            type='text'
                            name='OpBal'
                            value={row.OpBal}
                            placeholder="Balance"
                            style={{ marginBottom: '5px', border: 'none', backgroundColor: '#4caf50', padding: '6px', width: '100%', textAlign: 'right', fontWeight: 'bold' }}
                          />
                        </td>}

                        {(flag === "GRN" || flag === "CONS" || flag === "POC" || flag === "POS" || flag === "DESP" || flag === "MISSUE") && <td style={{ padding: '1px', border: '1px solid #333' }}>
                          <input
                            type='text'
                            name='ItemDesc'
                            value={row.ItemDesc}
                            onChange={(e) => handleInputChange(index, e)}
                            placeholder="Item Desc"
                            style={{ marginBottom: '5px', border: 'none', padding: '5px', width: '100%', }}
                          />
                        </td>}

                        {(flag === "GRN" || flag === "DESP") && <td style={{ padding: '1px', border: '1px solid #333' }}>
                          <input
                            type='text'
                            name='BatchNo'
                            value={row.BatchNo}
                            onChange={(e) => handleInputChange(index, e)}
                            placeholder="BatchNo"
                            style={{ marginBottom: '5px', border: 'none', padding: '5px', width: '100%', }}
                          />
                        </td>}
                        {(flag === "GRN") && <td style={{ padding: '1px', border: '1px solid #333' }}>
                          <input
                            type='date'
                            name='Mfg'
                            value={row.Mfg}
                            onChange={(e) => handleInputChange(index, e)}
                            placeholder="Manufacture Date"
                            style={{ marginBottom: '5px', border: 'none', padding: '5px', width: '100%', }}
                          />
                        </td>}

                        {(flag === "GRN") && <td style={{ padding: '1px', border: '1px solid #333' }}>
                          <input
                            type='date'
                            name='Expiry'
                            value={row.Expiry}
                            onChange={(e) => handleInputChange(index, e)}
                            placeholder="Expiry"
                            style={{ marginBottom: '5px', border: 'none', padding: '5px', width: '100%', }}
                          />
                        </td>}

                        {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "CONS" || flag === "DESP" || flag === "MISSUE") &&
                          <td style={{ padding: '1px', border: '1px solid #333' }}>
                            <input
                              name='Rate'
                              value={row.Rate}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="Rate"
                              style={{ marginBottom: '5px', border: 'none', padding: '5px', width: '100%', textAlign: 'right' }}
                            />
                          </td>}


                        {/* {(flag === "GRN" || flag === "CONS" || flag === "DESP" || flag === "MISSUE") && <td style={{ padding: '1px', border: '1px solid #333' }}>
                          <input
                            type='text'
                            value={row.Unit}
                            onChange={(e) => handleInputChange(index, e)}
                            placeholder="Unit"
                            style={{ marginBottom: '5px', border: 'none', padding: '5px', width: '100%', textAlign: 'right', }}
                          />
                        </td>} */}
                        {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "CONS" || flag === "DESP" || flag === "MISSUE") &&
                          <td style={{ padding: '1px', border: '1px solid #333' }}>
                            <input
                              type="number"
                              name="Qty"
                              value={row.Qty}
                              onChange={(e) => {
                                const newQty = parseFloat(e.target.value);
                                const currentOpBal = parseFloat(row.OpBal);

                                if (flag === 'DESP' && isStockCheckEnabled) {
                                  if (!isNaN(newQty) && !isNaN(currentOpBal)) {
                                    if (newQty > currentOpBal) {
                                      toast.warning(`Qty (${newQty}) is greater than Balance (${currentOpBal})`, { autoClose: 1000 });

                                      const updatedRows = [...rows];
                                      updatedRows[index] = {
                                        ...updatedRows[index],
                                        Qty: '',
                                      };
                                      setRows(updatedRows);
                                      return;
                                    }
                                  }
                                }
                                handleInputChange(index, e);
                              }}
                              placeholder="Qty"
                              style={{ padding: '5px', border: 'none', width: '100%', textAlign: 'right', }}
                            />
                          </td>}
                        {(flag === "POC" || flag === "DESP") &&
                          <td style={{ padding: '1px', border: '1px solid #333' }}>
                            <input
                              type="number"
                              name="Weight"
                              value={row.Weight}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="Weight"
                              style={{ padding: '5px', border: 'none', width: '100%', textAlign: 'right', }}
                            />
                          </td>}
                        {(flag === "GRN" || flag === "CONS" || flag === "POC" || flag === "POS" || flag === "DESP" || flag === "MISSUE") &&
                          <td style={{ padding: '1px', border: '1px solid #333' }}>
                            <input
                              name="TotalAmount"
                              value={row.Amt}
                              disabled
                              placeholder="TotalAmt"
                              style={{ marginBottom: '5px', border: 'none', padding: '5px', width: '100%', textAlign: 'right', }}
                            />
                          </td>}
                        {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "DESP") &&
                          <td style={{ padding: '1px', border: '1px solid #333' }}>
                            <select
                              value={row.GstRate || 0}
                              /*  onChange={(e) => {
                                 const selectedGstPercent = e.target.value;
                                 handleGstRateChange(selectedGstPercent);
                                 //console.log("selectedGstName :", selectedGstPercent);
                               }} */
                              onChange={(e) => {
                                const selectedGstPercent = e.target.value;
                                const updatedRows = [...rows];
                                updatedRows[index].GstRate = selectedGstPercent; // Update the GST rate for the specific row
                                setRows(updatedRows);
                                handleInputChange(index, { target: { name: 'Rate', value: row.Rate } }); // Recalculate the amounts
                              }}
                              style={{ padding: '5px', width: '100%', border: 'none' }}
                            >
                              {gstRates.map((group) => (
                                <option key={group.GSTRateCode} value={group.GSTPercent}>
                                  {group.GSTName}
                                </option>
                              ))}
                            </select>
                          </td>}
                        {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "DESP") &&
                          <td style={{ padding: '1px', border: '1px solid #333' }}>
                            <input
                              name="GstAmt"
                              value={row.GstAmt}
                              disabled
                              placeholder="GSTAmt"
                              style={{ marginBottom: '5px', border: 'none', padding: '5px', width: '100%', }}
                            />
                          </td>}
                        {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "DESP") &&
                          <td style={{ padding: '1px', border: '1px solid #333' }}>
                            <input
                              name="NetAmt"
                              value={row.NetAmt}
                              disabled
                              placeholder="NetAmt"
                              style={{ marginBottom: '5px', border: 'none', padding: '5px', width: '100%', textAlign: 'right', }}
                            />
                          </td>}

                        {(flag === "GRN" || flag === "DESP") &&
                          <td style={{ padding: '1px', border: '1px solid #333' }}>
                            <input
                              name="Narration"
                              value={row.Narration}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="Narration"
                              style={{ marginBottom: '5px', border: 'none', padding: '5px', width: '100%', }}
                            />
                          </td>}
                        {(flag === 'DESP') && (
                          <td style={{ width: '180px', border: '1px solid #333', padding: '2px', textAlign: 'center' }}>
                            <InfoIcon
                              style={{ cursor: 'pointer', color: '#007BFF', fontSize: '22px' }}
                              onClick={async () => {
                                const itCode = rows[index].ItCode;
                                if (!itCode) {
                                  toast.warning('RawItCode is empty', { autoClose: 760 });
                                  return;
                                }

                                if (formModeUpdate === 'add') {
                                  const savedEntry = savedBatch.filter(item => item.ItCode === parseInt(itCode));

                                  if (savedEntry.length > 0) {
                                    setFilteredRows(savedEntry);
                                    //toast.info('Displaying saved data for the selected ItCode.', { autoClose: 760 });
                                  } else {
                                    await handleBatchQty(getCurrentDate(), itCode);
                                  }
                                } else {
                                  if (trDate && entryNo) {
                                    await handleEditBatchQty(trDate, entryNo, itCode);
                                  } else {
                                    console.log('TrDate or EntryNo is missing');
                                  }
                                }
                                setTargetRowIndex(index);
                              }}
                            />
                          </td>
                        )}

                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr
                      style={{
                        position: 'sticky',
                        bottom: 0,
                        zIndex: 10,
                        backgroundColor: '#f1f1f1'
                      }}
                    >
                      <td
                        colSpan={
                          flag === 'GRN' ? 9
                            : flag === 'DESP' ? 7
                              : 6
                        }
                        style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}
                      >
                        <strong>Total</strong>
                      </td>

                      {(flag === "POC" || flag === "POS" || flag === "GRN" || flag === "CONS" || flag === "DESP" || flag === "MISSUE") && (
                        <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}>
                          <strong>{totalQty.toFixed(2)}</strong>
                        </td>
                      )}

                      {(flag === 'POC' || flag === 'DESP') && (
                        <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}>
                          <strong>{totalWeight.toFixed(2)}</strong>
                        </td>
                      )}
                    </tr>
                  </tfoot>

                  <tfoot>
                    <tr>
                      <td colSpan={Object.keys(rows[0] || {}).length + 1} style={{ textAlign: "left", padding: "2px", border: "1px solid #333" }}>
                        <button
                          onClick={handleAddRow}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            padding: "4px 12px",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "14px",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          ➕ Add Row
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                {<Dialog open={dialogOpen} onClose={handleCloseErrorDialog}>
                  <DialogTitle style={{ fontWeight: 'bold' }}>WARNING..!!!</DialogTitle>
                  <DialogContent>
                    <p style={{ color: 'red', fontSize: '14px' }}>{errorMessage}</p>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseErrorDialog} color="primary" autoFocus>
                      OK
                    </Button>
                  </DialogActions>
                </Dialog>}
              </div>
              <div>
                {showPDFComponent && (flag === "POS" || flag === "DESP") && (
                  <Invoice
                    tableData={requestData}
                    AcHead={SubLedgerMasterEntries.find(grp => grp.SubAcCode == SubAccode)?.SubAcHead}
                    AcAddress1={SubLedgerMasterEntries.find(grp => grp.SubAcCode == SubAccode)?.Address1}
                    AcAddress2={SubLedgerMasterEntries.find(grp => grp.SubAcCode == SubAccode)?.Address2}
                    ItemMaster={ItemMaster}
                    showPDFComponent={showPDFComponent}
                    flag={flag}
                    CompCode={props.selectedCompany}
                    CompName={compMasterEntries.find(grp => grp.CompCode == props.selectedCompany)?.CompName}
                  />
                )}
              </div>
              {<Dialog open={openDialog} onClose={handleClose} sx={{ '& .MuiDialog-paper': { width: '280px', maxWidth: '250px' } }}>
                <DialogTitle sx={{ fontSize: '16px' }}>Confirmation</DialogTitle>
                <DialogContent>
                  <DialogContentText sx={{ fontSize: '14px', marginLeft: '20px' }}>
                    Do you want PRINT...?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button color="inherit" onClick={handleCloseDialog} autoFocus>
                    No
                  </Button>
                  <Button color="inherit" autoFocus onClick={handleCloseDialogWithPrint}>
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>}

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '5px', backgroundColor: '#DEDADA', borderRadius: '5px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {/* {!showGrid && (
                    <Button
                      variant="contained"
                      onClick={handleAddRow}
                      sx={{
                        backgroundColor: "#1160AA",
                        color: "white",
                        fontWeight: "bold",
                        padding: "8px 20px",
                        fontSize: '12px',
                        width: "auto",
                        marginRight: '10px'
                      }}
                    >
                      Add Row
                    </Button>
                  )} */}
                  <Button
                    className={formModeUpdate === 'add' ? 'Save-button' : 'update-button'}
                    onClick={() => {
                      if (flag === 'POS' || flag === 'DESP') {
                        setOpenDialog(true);
                      } else {
                        AddEntry();
                      }
                    }}
                    style={{
                      padding: '8px 20px',
                      fontSize: '16px',
                      backgroundColor: formModeUpdate === 'add' ? '#4caf50' : '#2196f3',
                      color: 'white',
                      border: 'none',
                      cursor: 'pointer',
                      fontWeight: "bold",
                      marginLeft: '10px',
                      marginRight: '5px',
                      borderRadius: '5px'
                    }}
                  >
                    {formModeUpdate === 'add' ? 'Save' : 'Update'}
                  </Button>
                  <Button
                    className="view-button"
                    onClick={handleClearTemp}
                    style={{
                      padding: '8px 20px',
                      fontSize: '16px',
                      backgroundColor: '#f44336',
                      color: 'white',
                      border: 'none',
                      fontWeight: "bold",
                      cursor: 'pointer',
                      marginLeft: '10px'
                    }}
                  >
                    Exit
                  </Button>
                </div>

                {/* Input Fields Section */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '70%' }}>
                  {(flag === "GRN" || flag === "CONS") && (
                    <>
                      {/* <div style={{ marginRight: '10px', flex: '0.18' }}>
                        <label htmlFor="TotalCGST">TotalCGST</label>
                        <input
                          type="number"
                          value={TotCGST}
                          placeholder="Total CGST"
                          readOnly
                          style={{ padding: '3px', width: '100%', textAlign: 'right' }}
                        />
                      </div>
                      <div style={{ marginRight: '10px', flex: '0.2' }}>
                        <label htmlFor="TotalSGST">TotalSGST</label>
                        <input
                          type="number"
                          value={TotSGST}
                          placeholder="Total SGST"
                          readOnly
                          style={{ padding: '3px', width: '100%', textAlign: 'right' }}
                        />
                      </div>
                      <div style={{ marginRight: '10px', flex: '0.2' }}>
                        <label htmlFor="TotalIGST">TotalIGST</label>
                        <input
                          type="number"
                          value={TotIGST}
                          placeholder="Total IGST"
                          readOnly
                          style={{ padding: '3px', width: '100%', textAlign: 'right' }}
                        />
                      </div> */}
                      <div style={{ flex: '0.2' }}>
                        <label htmlFor="TotalAmt">TotalNetAmt</label>
                        <input
                          type="number"
                          value={NetAmt}
                          placeholder="TotalNetAmt"
                          readOnly
                          style={{
                            padding: '2px',
                            width: '100%',
                            textAlign: 'right',
                            fontWeight: 'bold',
                            fontSize: '15px',
                            backgroundColor: 'yellow'
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>

        {showGrid && (
          <div ref={componentPDF} style={{ width: '100%', overflowX: 'auto' }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              marginBottom={'14px'}
              sx={{ width: '100%' }}
            >
              <h2>{title}</h2>

              <div style={{ display: 'flex', gap: '10px' }}>
                <Button
                  variant="contained"
                  onClick={generatePDF}
                  sx={{ backgroundColor: "yellow", color: "black", '&:hover': { color: "white" } }}
                >
                  Download PDF
                </Button>

                <Button
                  variant="contained"
                  sx={{ backgroundColor: "yellow", color: "black", '&:hover': { color: "white" } }}
                >
                  Export
                </Button>

                <Button
                  variant="contained"
                  onClick={handleExitButtonClick}
                  sx={{ backgroundColor: "red", color: "white" }}
                >
                  Exit
                </Button>

                {(props.canAdd === true) && (<Button
                  variant="contained"
                  className="view-button"
                  onClick={handleshowandhide}
                  sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white" }}
                >
                  {showGrid ? 'Add' : 'Back'}
                </Button>)}
              </div>
            </Box>

            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                border: '1px solid #ccc',
              }}
            >
              <thead style={{ display: 'table', width: '100%' }}>
                <tr style={{ background: "#f2f2f2", color: "black" }}>
                  <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc', width: '10%'
                    }}
                  >
                    Flag
                  </th>
                  <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc', width: '10%'
                    }}
                  >
                    EntryNo
                  </th>
                  <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc', width: '10%'
                    }}
                  >
                    TrDate
                  </th>
                  {!(flag === "PROD") && <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc', width: '25%'
                    }}
                  >
                    Party/Supplier Name
                  </th>}
                  {!(flag === "SCRAP") && <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc', width: '10%'
                    }}
                  >
                    Qty
                  </th>}
                  <th
                    style={{
                      padding: '4px',
                      background: '#f2f2f2',
                      border: '1px solid #ccc', width: '10%'
                    }}
                    className="print-hide"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody style={{ display: "block", maxHeight: "500px", overflowY: "auto", width: '100%' }}>
                {ProcessEntry
                  .sort((a, b) => {
                    const dateA = new Date(a.TrDate);
                    const dateB = new Date(b.TrDate);
                    if (dateA > dateB) return -1;
                    if (dateA < dateB) return 1;
                    if (a.EntryNo > b.EntryNo) return -1;
                    if (a.EntryNo < b.EntryNo) return 1;
                    return 0;
                  })
                  .map((entry) => {
                    const selectedGroup = SubLedgerMasterEntries.find(group => group.SubAcCode == entry.SubAccode);
                    const uniqueKey = `${entry.EntryNo}-${entry.Flag}`;

                    if (!uniqueEntries.has(uniqueKey)) {
                      uniqueEntries.add(uniqueKey);
                      return (
                        <tr key={entry.EntryNo} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center', display: "table", width: "100%", tableLayout: "fixed" }}>
                          <td style={{ padding: '4px', border: '1px solid #ccc', width: '10%' }}>{entry.Flag}</td>
                          <td style={{ padding: '4px', border: '1px solid #ccc', width: '10%' }}>{entry.EntryNo}</td>
                          <td style={{ padding: '8px', border: '1px solid #ccc', width: '10%' }}>{new Date(entry.TrDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</td>
                          {<td style={{ padding: '8px', border: '1px solid #ccc', width: '25%' }}>
                            {selectedGroup ? `${selectedGroup.SubAcHead}` : ''}
                          </td>}
                          {<td style={{ padding: '4px', border: '1px solid #ccc', width: '10%' }}>{entryTotalNetAmt[entry.EntryNo]?.toFixed(2)}</td>}

                          <td className="print-hide" style={{ width: '10%', border: '1px solid #ccc' }}>
                            <button
                            className='action-btn btn-edit'
                              onClick={() => setEdit(entry.EntryNo)}
                            >
                              Edit
                            </button>
                            <button
                            className='action-btn btn-delete'
                              //onClick={() => deleteDistinctEntry(entry.EntryNo, entry.Flag)}
                              onClick={() => {
                                setDeleteEntryNo({ entryNo: entry.EntryNo, flag: entry.Flag });
                                setOpenConfirmation(true);
                              }}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      )
                    }
                  })}
              </tbody>
            </table>

            <div
              style={{
                position: 'sticky',
                bottom: 0,
                backgroundColor: 'white',
                textAlign: 'center',
                padding: '10px 0',
                borderTop: '1px solid #ccc',
              }}
            >
              <button
                onClick={() => {
                  const nextPage = currentPage + 1;
                  setCurrentPage(nextPage);
                  fetchProcessEntry(nextPage);
                }}
                disabled={!hasMoreData}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#000',
                  color: 'white',
                  border: 'none',
                  cursor: hasMoreData ? 'pointer' : 'not-allowed',
                  borderRadius: '4px',
                }}
              >
                {hasMoreData ? 'Load More' : 'No More Records'}
              </button>
            </div>

            {/* Confirmation Dialog */}
            <Dialog
              open={openConfirmation}
              onClose={() => setOpenConfirmation(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"CONFIRM DELETE"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to DELETE this Entry ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                  Cancel
                </Button>
                <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>

          </div>
        )}
        {/* Snackbar for displaying error messages */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // Center the Snackbar
        >
          <MuiAlert elevation={6} variant="filled" severity="error" sx={{ fontSize: '16px' }} onClose={handleCloseSnackbar}>
            {errorMessage}
          </MuiAlert>
        </Snackbar>

      </div>}
    </>

  );
}

export default SellEntry;